import React from 'react';
import { useSelector } from 'react-redux';
import { Container, Header, Segment, Breadcrumb, Icon, Image } from 'semantic-ui-react';
import ProfileManager from '../components/ProfileManager';
import profileIcon from '../assets/profileLineGlasses.svg'
import { HeaderAndPage } from '../common/components';
import { AuthStdFooter } from "../utils/auth-std-footer";
/**
 * ProfilePage component for managing user profiles
 * @returns {JSX.Element} ProfilePage component
 */
const ProfilePage = () => {
  const userId = useSelector(state => state.user.profile?.data?.userId);
  const activeRole = useSelector(state => state.user.userRole?.activeRole);

  // Get the appropriate dashboard path based on active role
  const getDashboardPath = () => {
    switch (activeRole) {
      case 'admin':
        return '/landing/admin';
      case 'bookCreator':
        return '/landing/book-creator';
      case 'voiceActor':
        return '/landing/voice-actor';
      default:
        return '/';
    }
  };

  return (
    <Container style={{ marginBottom: "70px", marginTop: '2rem' }}>
      <Breadcrumb size="large">
        <Breadcrumb.Section href={getDashboardPath()}>
          <Icon name="home" />
          Dashboard
        </Breadcrumb.Section>
        <Breadcrumb.Divider icon="right chevron" />
        <Breadcrumb.Section active>Profile Management</Breadcrumb.Section>
      </Breadcrumb>

      {/* 
      <Header as="h1" style={{ marginTop: '1rem' }}>
        <div className="img-with-gradient" style={{ padding: "20px" }}>
          <Image
            src={profileIcon}
            circular
            style={{ width: "150px", height: "120px" }}
          />
        </div>
        <Header.Content>
          My Profile
          <Header.Subheader>Manage your profile settings and roles</Header.Subheader>
        </Header.Content>
      </Header> */}
      <HeaderAndPage
        headerImage={profileIcon}
        headerText="My Profile"
        subHeaderText="Manage your profile settings and roles"
      >
        {userId ? (
          <ProfileManager userId={userId} />
        ) : (
          <Segment placeholder>
            <Header icon>
              <Icon name="warning sign" />
              You need to be logged in to manage your profile.
            </Header>
          </Segment>
        )}
      </HeaderAndPage>
      {AuthStdFooter()}

    </Container>
  );
};

export default ProfilePage;
